import _classnames from 'clsx';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import InputGroup from '../form/inputgroup/inputgroup';
import Panel from '../panel/panel';

/**
 * This is the panel component rendered by the Dropdown component.
 */
class DropdownPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inputValue: '',
    };
  }

  handleInputChange = (value) => {
    const { inputCallback } = this.props;
    this.setState({ inputValue: value });
    inputCallback(value);
  };

  render() {
    const {
      bodyClasses,
      children,
      footer,
      footerIsButton,
      inputPlaceholder,
      isLoading,
      isOpen,
      panelHasTopMargin,
      panelId,
      withTextInput,
    } = this.props;
    const { inputValue } = this.state;

    return (
      isOpen && (
        <Panel
          bodyClasses={bodyClasses}
          classes={_classnames('Dropdown__panel', {
            'Dropdown__panel--open': isOpen,
            'Dropdown__panel--margin-top': panelHasTopMargin,
          })}
          footer={footer}
          footerClasses={_classnames('Dropdown__panel__footer', {
            'Dropdown__panel__footer--is-button': footerIsButton,
          })}
          isLoading={isLoading}
          noBodyPadding
        >
          <div className="Dropdown__panel__container" id={panelId}>
            {withTextInput && (
              <InputGroup
                classes="Dropdown__panel__textinput"
                placeholder={inputPlaceholder}
                onChange={(e) => this.handleInputChange(e.target.value)}
                value={inputValue}
              />
            )}
            <ul className="Dropdown__panel__list">{children}</ul>
          </div>
        </Panel>
      )
    );
  }
}

DropdownPanel.propTypes = {
  /**
   * Classes automatically applied to the `Panel` from the `Dropdown` component
   */
  // eslint-disable-next-line react/forbid-prop-types
  bodyClasses: PropTypes.object,
  /**
   * `DropdownSection` components are rendered automatically as children inside the panel in a ul
   * based on the `Dropdown` component's items array
   */
  children: PropTypes.node,
  /**
   * Passed from `Dropdown` component and passed into the `Panel` component as footer
   */
  footer: PropTypes.node,
  /**
   * Adds classes to style the panel footer; set to true if footer is a single button
   */
  footerIsButton: PropTypes.bool,
  /**
   * Loading state displays the Loader component at the top of the panel
   */
  isLoading: PropTypes.bool,
  /**
   * Passed from `Dropdown` component; set to `true` to render the `DropdownPanel` or `false` to render nothing
   */
  isOpen: PropTypes.bool,
  /**
   * If the DropdownPanel contains an input (`withTextInput` prop), you may include a callback
   * which will run with the new input value as an argument any time the input value is changed.
   * (Passed automatically from `Dropdown` component)
   */
  inputCallback: PropTypes.func,
  /**
   * Generated automatically in `Dropdown` component, this value is the `id` value for the `div`
   * which wraps the `DropdownPanel` contents. The `panelId` is used to track the size of the panel
   * in the dom and ensure the active item in the panel is always visible.
   */
  panelId: PropTypes.string,
  /**
   * Passed from `Dropdown` component; set to `true` to include a text input at the top of the panel
   */
  withTextInput: PropTypes.bool,
  /**
   * Placeholder for empty input values
   */
  inputPlaceholder: PropTypes.string,
  panelHasTopMargin: PropTypes.bool,
};

DropdownPanel.defaultProps = {
  inputCallback: () => {},
  inputPlaceholder: '',
  bodyClasses: undefined,
  children: undefined,
  footer: undefined,
  footerIsButton: false,
  isLoading: false,
  isOpen: false,
  panelId: undefined,
  withTextInput: false,
  panelHasTopMargin: false,
};

export default DropdownPanel;
